export default "__VITE_ASSET__CqiMzTFF__"